module.exports = __webpack_public_path__ + "img/arrowReport.e25d2694.svg";